export { default as Menu } from './Menu';
export { default as Label } from './MenuLabel';
export { default as List } from './MenuList';
export { default as Link } from './MenuLink';


// WEBPACK FOOTER //
// ./src/components/Menu/index.ts